import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo, useRef } from 'react';
import clsx from 'clsx';
import { combineClasses, combineProps, styled, useEventCallback, useForkRef, useRcPortalWindowContext, useThemeProps, } from '../../foundation';
import { RcPopover } from '../Popover';
import { RcFade } from '../Transitions';
import { VirtualizedMenuStyle } from './styles';
import { RcVirtualizedMenuClasses } from './utils';
import { RcVirtualizedMenuList, } from './VirtualizedMenuList';
var _RcVirtualizedMenu = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcVirtualizedMenu' });
    var _a = props.autoFocus, autoFocus = _a === void 0 ? true : _a, children = props.children, classesProp = props.classes, _b = props.disableAutoFocusItem, disableAutoFocusItem = _b === void 0 ? false : _b, _c = props.MenuListProps, _d = _c === void 0 ? {} : _c, _e = _d.maxHeight, maxHeight = _e === void 0 ? 416 : _e, onKeyDown = _d.onKeyDown, VirtuosoProps = _d.VirtuosoProps, MenuListProps = __rest(_d, ["maxHeight", "onKeyDown", "VirtuosoProps"]), onClose = props.onClose, open = props.open, TransitionPropsProp = props.TransitionProps, _f = props.PaperProps, PaperPropsProp = _f === void 0 ? {} : _f, PopoverClasses = props.PopoverClasses, _g = props.transitionDuration, transitionDuration = _g === void 0 ? 'auto' : _g, _h = props.variant, variant = _h === void 0 ? 'selectedMenu' : _h, _j = props.action, popoverActionProp = _j === void 0 ? null : _j, rest = __rest(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "TransitionProps", "PaperProps", "PopoverClasses", "transitionDuration", "variant", "action"]);
    var document = useRcPortalWindowContext().document;
    var popoverRef = useRef(null);
    var handleRef = useForkRef(ref, popoverRef);
    var popoverAction = useRef(null);
    var handlePopoverAction = useForkRef(popoverAction, popoverActionProp);
    var menuListActionRef = useRef(null);
    var classes = useMemo(function () { return combineClasses(RcVirtualizedMenuClasses, classesProp); }, [classesProp]);
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var TransitionProps = useMemo(function () {
        return combineProps({
            onEntering: function () {
                var _a, _b;
                (_a = menuListActionRef.current) === null || _a === void 0 ? void 0 : _a.adjustStyleForScrollbar();
                (_b = menuListActionRef.current) === null || _b === void 0 ? void 0 : _b.scrollIntoViewAndFocus();
            },
            onEntered: function () {
                var _a;
                var popoverElm = popoverRef.current;
                var paperElm = popoverElm.querySelector("." + RcVirtualizedMenuClasses.paper);
                // check that paper height is same as vl scroll, if not adjust that containerHeight
                var newHeight = paperElm.clientHeight;
                if (newHeight !== maxHeight) {
                    (_a = menuListActionRef.current) === null || _a === void 0 ? void 0 : _a.adjustContainerHeight(newHeight);
                }
            },
        }, TransitionPropsProp);
    }, [maxHeight, TransitionPropsProp]);
    var PaperProps = combineProps({
        classes: {
            root: classes === null || classes === void 0 ? void 0 : classes.paper,
        },
    }, PaperPropsProp);
    var handleListKeyDown = useEventCallback(function (event) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) {
                onClose(event, 'tabKeyDown');
            }
        }
    });
    return (React.createElement(RcPopover, __assign({ ref: handleRef, action: handlePopoverAction, container: document.body, classes: PopoverClasses, onClose: onClose, open: open, 
        // FIXME: workaround for virtualized menu height incorrect issue
        TransitionComponent: RcFade, transitionDuration: transitionDuration, PaperProps: PaperProps, TransitionProps: TransitionProps }, rest),
        React.createElement(RcVirtualizedMenuList, __assign({ position: "unset", action: menuListActionRef, autoFocus: autoFocus, autoFocusItem: autoFocusItem, maxHeight: maxHeight, variant: variant, onKeyDown: handleListKeyDown, VirtuosoProps: __assign(__assign({}, VirtuosoProps), { totalListHeightChanged: function (height) {
                    var _a;
                    (_a = VirtuosoProps === null || VirtuosoProps === void 0 ? void 0 : VirtuosoProps.totalListHeightChanged) === null || _a === void 0 ? void 0 : _a.call(VirtuosoProps, height);
                    // fix for popover position incorrect issue
                    queueMicrotask(function () {
                        var _a;
                        (_a = popoverAction.current) === null || _a === void 0 ? void 0 : _a.updatePosition();
                    });
                } }) }, MenuListProps, { className: clsx(classes.list, MenuListProps.className) }), children)));
});
var RcVirtualizedMenu = styled(_RcVirtualizedMenu)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), VirtualizedMenuStyle);
RcVirtualizedMenu.defaultProps = {
    autoFocus: true,
    variant: 'selectedMenu',
    getContentAnchorEl: null,
    anchorReference: 'anchorEl',
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
};
export { RcVirtualizedMenu };
var templateObject_1;
